import { useState, useCallback } from 'react';
const useExpandable = (initialState = true) => {
    const [expanded, setExpanded] = useState(initialState);
    const onExpand = useCallback(() => {
        setExpanded(true);
    }, []);
    const onCollapse = useCallback(() => {
        setExpanded(false);
    }, []);
    return { expanded, onExpand, onCollapse };
};
export default useExpandable;
